export default __webpack_public_path__ + "img/mv_about.jpeg";